import { render, staticRenderFns } from "./OrgObjectTreeList.vue?vue&type=template&id=98806e9e"
import script from "./OrgObjectTreeList.vue?vue&type=script&lang=js"
export * from "./OrgObjectTreeList.vue?vue&type=script&lang=js"
import style0 from "./OrgObjectTreeList.vue?vue&type=style&index=0&id=98806e9e&prod&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports